import Footer2 from "../Footer2";
import Trusted from "../Trusted";

import StartupDiv1 from "./StartupDiv1";
import StartupDiv2 from "./StartupDiv2";

function Startup() {
    return (
    <div>
        <StartupDiv1/>
        <StartupDiv2/>
        <Trusted/>
        <Footer2/>
    </div>
    );
  }
  
  export default Startup;
  